import { AppFullRoutes } from '../enum/appRoutes';
import { MenuItem } from '../interfaces/menu-item.interface';
import { Permission } from './permissionConstants';

export const NAV_ITEMS: MenuItem[] = [
  {
    name: 'Dashboard',
    key: 'dashboard',
    icon: 'grid_view',
    link: AppFullRoutes.FULL_USER_DASHBOARD,
    submenu: null,
    isMaterialIcon: true,
    permission: Permission.DASHBOARD,
  },
  {
    name: 'Administration',
    key: 'administration',
    icon: 'bx bx-user-check',
    link: '/',
    permission: Permission.ADMINISTRATION,
    submenu: [
      {
        name: 'User Management',
        key: 'user-management',
        icon: 'bx bx-list-check',
        link: AppFullRoutes.FULL_USER_MANAGEMENT,
        permission: Permission.USER_MANAGEMENT,
      },
      {
        name: 'Roles',
        key: 'role-permission',
        icon: 'approval_delegation',
        link: AppFullRoutes.FULL_ROLE_PERMISSION,
        isMaterialIcon: true,
        permission: Permission.ROLE_MANAGEMENT,
      },
      {
        name: 'Permissions',
        key: 'permission-management',
        icon: 'approval_delegation',
        link: AppFullRoutes.FULL_PERMISSION_MANAGEMENT,
        isMaterialIcon: true,
        permission: Permission.PERMISSION_MANAGEMENT,
      },
      {
        name: 'SLA Management',
        key: 'sla-management',
        icon: 'schedule',
        link: AppFullRoutes.FULL_SLA_MANAGEMENT,

        // permission: Permission.SYSTEM_CONFIGURATION,
        isMaterialIcon: true,
      },
    ],
  },
  // {
  //   name: 'Role Management',
  //   key: 'role-permission',
  //   icon: 'approval_delegation',
  //   link: AppFullRoutes.FULL_ROLE_PERMISSION,
  //   submenu: null,
  //   isMaterialIcon: true,
  // },
  // {
  //   name: 'Permission Management',
  //   key: 'permission-management',
  //   icon: 'approval_delegation',
  //   link: AppFullRoutes.FULL_PERMISSION_MANAGEMENT,
  //   submenu: null,

  //   isMaterialIcon: true,
  // },
  {
    name: 'Billing & Payment',
    key: 'billing-payment',
    icon: 'bx bx-money',
    link: '#',
    permission: Permission.BILLING_PAYMENT,
    submenu: [
      {
        name: 'Capitation Payments',
        key: 'capitation',
        icon: 'bx bx-list-check',
        link: AppFullRoutes.FULL_CAPITATION_BILLING_PAYMENT,
        // permission: Permission.PREMIUM_CONTRIBUTIONS,
      },
      {
        name: 'Premium & Contributions',
        key: 'premium-contribution',
        icon: 'bx bx-list-check',
        link: AppFullRoutes.FULL_BILLING_PAYMENT,
        // permission: Permission.PREMIUM_CONTRIBUTIONS,
      },
      {
        name: 'Claims Payments',
        key: 'claims-financing-provider-payments',
        icon: 'bx bx-transfer',
        link: AppFullRoutes.FULL_CLAIM_FINANCING_PROVIDER_PAYMENT,
        permission: Permission.PAYMENT_CLAIMS_FINANCING,
      },
      // {
      //   name: 'Refunds & Adjustments',
      //   key: 'refunds-adjustments',
      //   icon: 'bx bx-receipt',
      //   link: AppFullRoutes.FULL_REFUNDS_ADJUSTMENTS,
      //   permission: Permission.REFUNDS_ADJUSTMENTS,
      // },
    ],
  },
  {
    name: 'Billing & Credits',
    key: 'billing-credits',
    icon: 'account_balance_wallet',
    link: '#',
    isMaterialIcon: true,
    // Add permission after the backend/auth permission is available.
    // permission: Permission.BILLING_CREDITS,
    submenu: [
      {
        name: 'Overview',
        key: 'billing-credits-overview',
        icon: 'dashboard',
        link: AppFullRoutes.FULL_BILLING_CREDITS_OVERVIEW,
        isMaterialIcon: true,
      },
      {
        name: 'Organization Wallets',
        key: 'organization-wallets',
        icon: 'account_balance_wallet',
        link: AppFullRoutes.FULL_ORGANIZATION_WALLETS,
        isMaterialIcon: true,
      },
      {
        name: 'Credit Purchases',
        key: 'credit-purchases',
        icon: 'shopping_cart',
        link: AppFullRoutes.FULL_CREDIT_PURCHASES,
        isMaterialIcon: true,
      },
      {
        name: 'Transactions',
        key: 'wallet-transactions',
        icon: 'receipt_long',
        link: AppFullRoutes.FULL_WALLET_TRANSACTIONS,
        isMaterialIcon: true,
      },
      {
        name: 'Usage Events',
        key: 'usage-events',
        icon: 'data_usage',
        link: AppFullRoutes.FULL_USAGE_EVENTS,
        // permission: Permission.USAGE_EVENTS,
        isMaterialIcon: true,
      },
      {
        name: 'Service Catalogue',
        key: 'billing-service-catalogue',
        icon: 'view_list',
        link: AppFullRoutes.FULL_BILLING_SERVICE_CATALOGUE,
        isMaterialIcon: true,
      },
      {
        name: 'Credit Packages',
        key: 'credit-packages',
        icon: 'inventory_2',
        link: AppFullRoutes.FULL_CREDIT_PACKAGES,
        isMaterialIcon: true,
      },
    ],
  },
  {
    name: 'Billing & Credits',
    key: 'organization-billing-credits',
    icon: 'account_balance_wallet',
    link: AppFullRoutes.FULL_ORGANIZATION_BILLING_OVERVIEW,
    // permission: Permission.WALLET_VIEW,
    isMaterialIcon: true,
    submenu: [
      {
        name: 'Overview',
        key: 'organization-billing-overview',
        icon: 'dashboard',
        link: AppFullRoutes.FULL_ORGANIZATION_BILLING_OVERVIEW,
        // permission: Permission.WALLET_VIEW,
        isMaterialIcon: true,
      },
      {
        name: 'Transactions',
        key: 'organization-billing-transactions',
        icon: 'receipt_long',
        link: AppFullRoutes.FULL_ORGANIZATION_BILLING_TRANSACTIONS,
        // permission:
        //   Permission.WALLET_TRANSACTIONS_VIEW,
        isMaterialIcon: true,
      },
      {
        name: 'Credit Purchases',
        key: 'organization-credit-purchases',
        icon: 'shopping_cart',
        link: AppFullRoutes.FULL_ORGANIZATION_CREDIT_PURCHASES,
        // permission: Permission.WALLET_PURCHASE,
        isMaterialIcon: true,
      },
    ],
  },

  {
    name: 'Claims Oversight',
    key: 'claims-oversight',
    icon: 'monitoring',
    link: AppFullRoutes.FULL_CLAIMS_OVERSIGHT_OVERVIEW,
    submenu: null,
    isMaterialIcon: true,

    // Add when backend/auth permission exists.
    // permission: Permission.CLAIMS_OVERSIGHT,
  },
  {
    name: 'Premiums',
    key: 'premiums-payment',
    icon: 'bx bx-money',
    link: '#',
    submenu: [
      {
        name: 'Premium & Contributions',
        key: 'premium-contribution',
        icon: 'bx bx-list-check',
        link: AppFullRoutes.FULL_BILLING_PAYMENT,
        // permission: Permission.PREMIUM_CONTRIBUTIONS,
      },
    ],
  },
  {
    name: 'Contributions & Billing',
    key: 'contributions-billing',
    icon: 'bx bx-money',
    link: AppFullRoutes.FULL_CONTRIBUTION_BILLING,
    submenu: null,
    permission: Permission.CONTRIBUTIONS_BILLING,
  },
  {
    name: 'Encounters & Referrals',
    key: 'encounters-referrals',
    icon: 'bx bx-link',
    link: AppFullRoutes.FULL_ENCOUNTER_REFERRAL,
    submenu: null,
    // permission: Permission.ENCOUNTER_REFERRAL,
  },

  {
    name: 'Master',
    key: 'master',
    icon: 'bx bx-brightness',
    link: '#',
    permission: Permission.MASTER,
    submenu: [
      {
        name: 'Payment Gateway',
        key: 'payment-gateway',
        icon: 'bx bx-credit-card',
        link: AppFullRoutes.FULL_PAYMENT_GATEWAY,
        // permission: Permission.PAYMENT_GATEWAY,
      },
      {
        name: 'Manage Health Plans',
        key: 'manage-health-plan',
        icon: 'bx bxs-parking',
        link: AppFullRoutes.FULL_MANAGE_INSURANCE_PLAN,
        permission: Permission.MANAGE_HEALTH_PLAN,
      },
      {
        name: 'Manage Health Services',
        key: 'manage-health-service',
        icon: 'bx bx-plus',
        link: AppFullRoutes.FULL_MANAGE_MEDICAL_SERVICE,
        permission: Permission.MANAGE_HEALTH_SERVICE,
      },
      // {
      //   name: 'Manage Role',
      //   key: 'manage-role',
      //   icon: 'bx bx-cog',
      //   link: AppFullRoutes.FULL_MANAGE_ROLE,
      // },
      // {
      //   name: 'Manage Payer',
      //   key: 'manage-payer',
      //   icon: 'bx bx-credit-card-alt',
      //   link: AppFullRoutes.FULL_MANAGE_PAYER,
      // },
    ],
  },
  {
    name: 'System Configuration',
    key: 'system-configuration',
    icon: 'rule_settings',
    link: AppFullRoutes.FULL_SYSTEM_CONFIGURATION,
    submenu: null,
    permission: Permission.SYSTEM_CONFIGURATION,
    // submenu: [
    //   {
    //     name: 'Configuration Management',
    //     key: 'configuration-management',
    //     icon: 'bx bx-list-check',
    //     link: AppFullRoutes.FULL_SYSTEM_CONFIGURATION,
    //   },
    //   {
    //     name: 'Add Configuration',
    //     key: 'add-configuration',
    //     icon: 'bx bx-list-plus',
    //     link: AppFullRoutes.FULL_ADD_SYSTEM_CONFIGURATION,
    //   },
    // ],
    isMaterialIcon: true,
  },
  {
    name: 'Payer & HMO',
    key: 'payer-hmo',
    icon: 'bx bx-link',
    link: AppFullRoutes.FULL_PAYER,
    submenu: null,
    // submenu: [
    //   {
    //     name: 'Payer Management',
    //     key: 'payer-management',
    //     icon: 'bx bx-list-check',
    //     link: AppFullRoutes.FULL_PAYER,
    //   },
    //   {
    //     name: 'Add New Payer',
    //     key: 'add-new-payer',
    //     icon: 'bx bx-list-plus',
    //     link: AppFullRoutes.FULL_ADD_PAYER_ACTIVITY,
    //   },
    // ],
  },
  {
    name: 'Subscription Management',
    key: 'subscription-management',
    icon: 'payments',
    link: AppFullRoutes.FULL_SUBSCRIPTION_MANAGEMENT,
    submenu: null,
    permission: Permission.SUBSCRIPTION_MANAGEMENT,
    // submenu: [
    //   {
    //     name: 'Manage Subscriptions',
    //     key: 'manage-subscriptions',
    //     icon: 'bx bx-list-check',
    //     link: AppFullRoutes.FULL_SUBSCRIPTION_MANAGEMENT,
    //   },
    //   {
    //     name: 'Add New Subscription',
    //     key: 'add-new-subscription',
    //     icon: 'bx bx-list-plus',
    //     link: AppFullRoutes.FULL_ADD_SUBSCRIPTION_MANAGEMENT,
    //   },
    // ],
    isMaterialIcon: true,
  },
  {
    name: 'Reports & Analytics',
    key: 'reports-analytics',
    icon: 'download',
    // link: AppFullRoutes.FULL_REPORTS_ANALYTICS,
    link: AppFullRoutes.FULL_REPORTS,
    submenu: null,
    // permission: Permission.REPORT_ANALYTICS,
    // submenu: [
    //   {
    //     name: 'Manage Reports',
    //     key: 'manage-reports',
    //     icon: 'bx bx-list-check',
    //     link: AppFullRoutes.FULL_REPORTS_ANALYTICS,
    //   },
    //   {
    //     name: 'Add New Report',
    //     key: 'add-new-report',
    //     icon: 'bx bx-list-plus',
    //     link: AppFullRoutes.FULL_ADD_REPORTS_ANALYTICS,
    //   },
    // ],
    isMaterialIcon: true,
  },
  {
    name: 'Audit & Activity',
    key: 'audit-activity',
    icon: 'notifications',
    link: AppFullRoutes.FULL_AUDIT_ACTIVITY,
    submenu: null,
    permission: Permission.AUDIT_ACTIVITY,
    // submenu: [
    //   {
    //     name: 'Manage Audit & Activity',
    //     key: 'manage-audit-activity',
    //     icon: 'bx bx-list-check',
    //     link: AppFullRoutes.FULL_AUDIT_ACTIVITY,
    //   },
    //   {
    //     name: 'Add New Audit & Activity',
    //     key: 'add-new-audit-activity',
    //     icon: 'bx bx-list-plus',
    //     link: AppFullRoutes.FULL_ADD_AUDIT_ACTIVITY,
    //   },
    // ],
    isMaterialIcon: true,
  },
  // {
  //   name: 'Accreditation',
  //   key: 'accreditation',
  //   icon: 'verified_user',
  //   link: AppFullRoutes.FULL_ACCREDITATION_MANAGEMENT,
  //   submenu: null,
  //   isMaterialIcon: true,
  //   permission: Permission.ACCREDITATION,
  // },
  {
    name: 'Authorization Management',
    key: 'authorization',
    icon: 'bx bx-shield-quarter',
    link: '#',
    submenu: [
      {
        name: 'Pre-Authorization',
        key: 'pre-authorization',
        icon: 'bx bx-check-circle',
        link: AppFullRoutes.FULL_PRE_AUTHORIZATION,
        submenu: null,
        // permission: Permission.PRE_AUTHORIZATION,
      },
      {
        name: 'Queued Authorizations',
        key: 'authorization-queues',
        icon: 'bx bx-list-check',
        link: AppFullRoutes.FULL_AUTHORIZATION_QUEUE,
      },
      {
        name: 'Review Workbench',
        key: 'authorization-review-workbench',
        icon: 'fact_check',
        link: AppFullRoutes.FULL_AUTHORIZATION_WORKBENCH,
        isMaterialIcon: true,
      },
      {
        name: 'Authorization Code Manager',
        key: 'authorization-code-manager',
        icon: 'vpn_key',
        link: AppFullRoutes.FULL_AUTHORIZATION_CODE_MANAGER,
        isMaterialIcon: true,
      },
      {
        name: 'Consumption Manager',
        key: 'authorization-consumption-manager',
        icon: 'analytics',
        link: AppFullRoutes.FULL_AUTHORIZATION_CONSUMPTION_MANAGER,
        isMaterialIcon: true,
      },
      {
        name: 'Referral Requests',
        key: 'referral-management',
        icon: 'bx bx-trip',
        link: AppFullRoutes.FULL_REFERRAL_MANAGEMENT,
        // permission: Permission.REFERRAL_REQUESTS,
      },

      {
        name: 'Referral Workbench',
        key: 'add-new-referral',
        icon: 'bx bx-link-alt',
        link: AppFullRoutes.FULL_REFERRAL_WORKBENCH,
        // permission: Permission.REFERRAL_WORKBENCH,
      },
    ],
  },
  {
    name: 'Accreditation Status',
    key: 'accreditation-status',
    icon: 'bx bx-user-check',
    link: AppFullRoutes.FULL_ACCREDITATION_STATUS,
    submenu: null,
    permission: Permission.ACCREDITATION_STATUS,
  },
  {
    name: 'Feedback',
    key: 'feedback',
    icon: 'bx bx-comment-detail',
    link: AppFullRoutes.FULL_FEEDBACK,
    submenu: null,
    // permission: Permission.FEEDBACK,
  },
  {
    name: 'Eligibility Check',
    key: 'eligibility-check',
    link: AppFullRoutes.FULL_ELIGIBILITY_CHECK,
    submenu: null,
    icon: 'diversity_3',
    isMaterialIcon: true,
    permission: Permission.ELIGIBILITY_CHECK,
  },
  // {
  //   name: 'Pre-Authorization',
  //   key: 'pre-authorization',
  //   icon: 'bx bx-check-circle',
  //   link: AppFullRoutes.FULL_PRE_AUTHORIZATION,
  //   submenu: null,
  //   permission: Permission.PRE_AUTHORIZATION,
  // },
  {
    name: 'Beneficiary',
    key: 'beneficiary',
    icon: 'bx bx-check-circle',
    link: '',
    // permission: Permission.ENROLLES_MANAGEMENT,
    submenu: [
      {
        name: 'Formal',
        key: 'formal-enrollee',
        icon: 'badge',
        link: AppFullRoutes.FULL_FORMAL_ENROLLEE,
        isMaterialIcon: true,
        permission: Permission.FORMAL,
      },
      {
        name: 'Informal',
        key: 'informal-enrollee',
        icon: 'account_circle',
        link: AppFullRoutes.FULL_INFORMAL_ENROLLEE,
        isMaterialIcon: true,
        permission: Permission.INFORMAL,
      },
      {
        name: 'GIFSHIP',
        key: 'gifship-enrollee',
        icon: 'diversity_1',
        link: AppFullRoutes.FULL_GIFSHIP_ENROLLEES,
        isMaterialIcon: true,
        // permission: Permission.GIFSHIP,
      },
      {
        name: 'VGP',
        key: 'vgp-enrollee',
        icon: 'diversity_2',
        link: AppFullRoutes.FULL_VGP_ENROLLEE,
        isMaterialIcon: true,
        permission: Permission.VGP,
      },
      {
        name: 'BHCPF',
        key: 'bhcpf-enrollee',
        icon: 'health_and_safety',
        link: AppFullRoutes.FULL_BHCPF_ENROLLEE,
        isMaterialIcon: true,
        permission: Permission.BHCPF,
      },
      {
        name: 'Private Scheme',
        key: 'private-enrollee',
        icon: 'verified_user',
        link: AppFullRoutes.FULL_PRIVATE_ENROLLEES,
        isMaterialIcon: true,
      },
      {
        name: 'Dependents',
        key: 'dependent-enrollee',
        icon: 'diversity_3',
        link: AppFullRoutes.FULL_DEPENDENT_ENROLLEE,
        isMaterialIcon: true,
        permission: Permission.DEPENDENTS,
      },
      {
        name: 'Employer',
        key: 'employer-group',
        icon: 'groups',
        link: AppFullRoutes.FULL_EMPLOYER_GROUP_MANAGEMENT,
        isMaterialIcon: true,
        permission: Permission.EMPLOYER_GROUP_MANAGEMENT,
      },

      {
        name: 'Self Enrollment',
        key: 'self-enrollee',
        icon: 'assignment_ind',
        link: AppFullRoutes.FULL_SELF_ENROLLEE,
        isMaterialIcon: true,
        permission: Permission.SELF_ENROLLMENT,
      },
      {
        name: 'Program Provider',
        key: 'program-provider',
        icon: 'apartment',
        link: AppFullRoutes.FULL_PROGRAM_PROVIDER,
        isMaterialIcon: true,
        permission: Permission.PROGRAM_PROVIDER,
      },
      {
        name: 'Membership Synchronization',
        key: 'membership-synchronization',
        icon: 'sync_alt',
        link: AppFullRoutes.FULL_MEMBERSHIP_SYNCHRONIZATION,
        isMaterialIcon: true,
        // permission: Permission.PROGRAM_PROVIDER,
      },
    ],
  },

  {
    name: 'Claims',
    key: 'claims',
    icon: 'bx bx-box',
    link: '#',
    // permission: Permission.CLAIMS,
    submenu: [
      {
        name: 'Claims Inbox',
        key: 'claims-management',
        icon: 'bx bx-mail-send',
        link: AppFullRoutes.FULL_CLAIM_INBOX,
        permission: Permission.CLAIMS_INBOX,
      },
      {
        name: 'Claims Review & Validation',
        key: 'claims-review-validation',
        icon: 'bx bx-search-alt',
        link: AppFullRoutes.FULL_CLAIM_REVIEW_VALIDATION,
        permission: Permission.CLAIMS_REVIEW_VALIDATION,
      },
      {
        name: 'Claims Adjudication',
        key: 'claims-adjudication',
        icon: 'bx bx-clipboard',
        link: AppFullRoutes.FULL_CLAIM_ADJUDICATION,
        permission: Permission.CLAIMS_ADJUDICATION,
      },
      {
        name: 'Claim Payments',
        key: 'claims-payments',
        icon: 'bx bx-credit-card',
        link: AppFullRoutes.FULL_CLAIM_PAYMENTS,
        permission: Permission.CLAIMS_PAYMENTS,
      },

      {
        name: 'Claim Pre-Authorizations',
        key: 'claims-pre-authorization',
        icon: 'bx bx-check-double',
        link: AppFullRoutes.FULL_CLAIM_PRE_AUTHORIZATION,
        permission: Permission.CLAIMS_PRE_AUTHORIZATIONS,
      },
      // {
      //   name: 'Claim Document Review',
      //   key: 'claims-document-review',
      //   icon: 'bx bx-file',
      //   link: AppFullRoutes.FULL_CLAIM_DOCUMENT_REVIEW,
      //   permission: Permission.CLAIMS_DOCUMENT_REVIEW,
      // },
      // {
      //   name: 'AI Claim Vetting',
      //   key: 'ai-claims-vetting',
      //   icon: 'bx bx-brain',
      //   link: AppFullRoutes.FULL_AI_CLAIM_VETTING,
      //   permission: Permission.AI_CLAIM_VETTING,
      // },
      // {
      //   name: 'Claims Reports & Analytics',
      //   key: 'claims-report-analytics',
      //   icon: 'bx bx-line-chart',
      //   link: AppFullRoutes.FULL_CLAIM_REPORT_ANALYTICS,
      //   permission: Permission.CLAIMS_REPORT_ANALYTICS,
      // },
    ],
  },

  {
    name: 'HMO',
    key: 'hmo',
    icon: 'bx bx-shield',
    link: AppFullRoutes.FULL_HMO_MANAGEMENT,
    // permission: Permission.HMO_MANAGEMENT,
    submenu: null,
    // submenu: [
    //   {
    //     name: 'HMO Management',
    //     key: 'hmo-management',
    //     icon: 'bx bxs-package',
    //     link: AppFullRoutes.FULL_HMO_MANAGEMENT,
    //   },
    //   {
    //     name: 'Add New HMO',
    //     key: 'add-new-hmo',
    //     icon: 'bx bx-cross',
    //     link: AppFullRoutes.FULL_HMO_MANAGEMENT_FORM,
    //   },
    // ],
  },

  {
    name: 'Referral',
    key: 'referral',
    icon: 'bx bx-link',
    link: '#',
    // permission: Permission.REFERRAL,
    submenu: [
      {
        name: 'Referral Requests',
        key: 'referral-management',
        icon: 'bx bx-trip',
        link: AppFullRoutes.FULL_REFERRAL_MANAGEMENT,
        // permission: Permission.REFERRAL_REQUESTS,
      },
      {
        name: 'Auth Code Manager',
        key: 'authorization-code-manager',
        icon: 'bx bx-highlight',
        link: AppFullRoutes.FULL_CODE_MANAGER,
        // permission: Permission.AUTH_CODE_MANAGER,
      },

      {
        name: 'Referral Workbench',
        key: 'add-new-referral',
        icon: 'bx bx-link-alt',
        link: AppFullRoutes.FULL_REFERRAL_WORKBENCH,
        // permission: Permission.REFERRAL_WORKBENCH,
      },
    ],
  },

  {
    name: 'Provider Network',
    key: 'provider',
    icon: 'bx bx-plus-medical',
    link: '/',
    permission: Permission.PROVIDER_MANAGEMENT,
    submenu: [
      {
        name: 'Provider Management',
        key: 'provider-management',
        icon: 'bx bx-highlight',
        link: AppFullRoutes.FULL_PROVIDER_MANAGEMENT,
        permission: Permission.PROVIDER_MANAGEMENT,
      },
      {
        name: 'Accreditation',
        key: 'accreditation',
        icon: 'verified_user',
        link: AppFullRoutes.FULL_ACCREDITATION_MANAGEMENT,
        isMaterialIcon: true,
        permission: Permission.ACCREDITATION,
      },
      {
        name: 'External Provider',
        key: 'external-provider',
        icon: 'bx bx-world',
        link: AppFullRoutes.FULL_EXTERNAL_PROVIDER,
      },
    ],
  },

  {
    name: 'Policy',
    key: 'policy',
    icon: 'bx bx-plus-circle',
    link: '/',
    permission: Permission.POLICY_MANAGEMENT,
    submenu: [
      {
        name: 'Benefits Package',
        key: 'catalog',
        icon: 'bx bx-note',
        link: AppFullRoutes.FULL_POLICY_CATALOG,
        permission: Permission.CATALOG,
      },

      {
        name: 'Plan',
        key: 'program',
        icon: 'desktop_landscape',
        link: AppFullRoutes.FULL_POLICY_PROGRAM,
        isMaterialIcon: true,
        permission: Permission.PROGRAMS,
      },
      {
        name: 'Pricing',
        key: 'pricing',
        icon: 'money_range',
        link: AppFullRoutes.FULL_POLICY_PRICING,
        isMaterialIcon: true,
        permission: Permission.PRICING,
      },
      {
        name: 'Capitations',
        key: 'capitations',
        icon: 'payments',
        link: AppFullRoutes.FULL_POLICY_CAPITATIONS_MODULE,
        isMaterialIcon: true,
        // permission: Permission.CAPITATIONS,
      },
    ],
  },

  {
    name: 'Report',
    key: 'report',
    icon: 'bx bxs-report',
    // link: AppFullRoutes.FULL_REPORTS,
    link: '/',
    submenu: [
      {
        name: 'National Foundation',
        key: 'catalog',
        icon: 'bx bx-note',
        link: AppFullRoutes.FULL_NATIONAL_FOUND_REPORT,
      },
    ],
    // permission: Permission.REPORT,
  },

  {
    name: 'Audit',
    key: 'audit',
    icon: 'bx bxl-blender',
    link: AppFullRoutes.FULL_AUDIT_MANAGEMENT,
    submenu: null,
    permission: Permission.AUDIT,
    // submenu: [
    //   {
    //     name: 'Audit Management',
    //     key: 'audit-management',
    //     icon: 'bx bx-cog',
    //     link: AppFullRoutes.FULL_AUDIT_MANAGEMENT,
    //   },

    //   {
    //     name: 'Add New Audit',
    //     key: 'add-new-audit',
    //     icon: 'bx bx-plus',
    //     link: AppFullRoutes.FULL_AUDIT_MANAGEMENT_FORM,
    //   },
    // ],
  },

  {
    name: 'Employee Management',
    key: 'employee-management',
    icon: 'groups',
    link: AppFullRoutes.FULL_EMPLOYEE_MANAGEMENT,
    submenu: null,
    isMaterialIcon: true,
    permission: Permission.EMPLOYEE_MANAGEMENT,
  },
  {
    name: 'Dependant Management',
    key: 'dependant-management',
    icon: 'diversity_3',
    link: AppFullRoutes.FULL_DEPENDANT_MANAGEMENT,
    submenu: null,
    isMaterialIcon: true,
    permission: Permission.DEPENDANT_MANAGEMENT,
  },
  {
    name: 'Programs & Providers',
    key: 'programs-providers',
    icon: 'bx bx-plus-medical',
    link: AppFullRoutes.FULL_PROGRAMS_PROVIDERS,
    submenu: null,
    permission: Permission.PROGRAMS_PROVIDERS,
  },
  {
    name: 'Documents Management',
    key: 'documents-management',
    icon: 'description',
    link: AppFullRoutes.FULL_DOCUMENTS,
    submenu: null,
    isMaterialIcon: true,
    permission: Permission.DOCUMENTS_MANAGEMENT,
  },
  {
    name: 'Encounter Management',
    key: 'encounter',
    icon: 'admin_meds',
    link: AppFullRoutes.FULL_ENCOUNTER_MANAGEMENT,
    submenu: null,
    isMaterialIcon: true,
    permission: Permission.ENCOUNTER_MANAGEMENT,
  },
  {
    name: 'Customer Support',
    key: 'support-center',
    icon: 'groups',
    link: AppFullRoutes.FULL_SUPPORT_CENTER,
    submenu: null,
    isMaterialIcon: true,
    // permission: Permission.SUPPORT_CENTER,
  },
  {
    name: 'Fraud Monitoring',
    key: 'fraud-monitoring',
    icon: 'shield',
    link: '/',
    submenu: [
      {
        name: 'Fraud Monitoring',
        key: 'fraud-monitoring',
        icon: 'monitoring',
        link: AppFullRoutes.FULL_FRAUD_MONITORING,
        // permission: Permission.FRAUD_MONITORING,
        isMaterialIcon: true,
      },
      {
        name: 'Fraud Investigations',
        key: 'fraud-investigations',
        icon: 'manage_search',
        link: AppFullRoutes.FULL_FRAUD_INVESTIGATIONS,
        // permission: Permission.FRAUD_INVESTIGATIONS,
        isMaterialIcon: true,
      },
      {
        name: 'Sanctions & Enforcement',
        key: 'sanctions-enforcement',
        icon: 'gavel',
        link: AppFullRoutes.FULL_SANCTIONS_ENFORCEMENT,
        // permission: Permission.SANCTIONS_ENFORCEMENT,
        isMaterialIcon: true,
      },
      {
        name: 'Compliance Monitoring',
        key: 'compliance-monitoring',
        icon: 'fact_check',
        link: AppFullRoutes.FULL_COMPLIANCE_MONITORING,
        // permission: Permission.COMPLIANCE_MONITORING,
        isMaterialIcon: true,
      },
      {
        name: 'Audit Logs',
        key: 'audit-logs',
        icon: 'receipt_long',
        link: AppFullRoutes.FULL_AUDIT_LOGS,
        // permission: Permission.AUDIT_LOGS,
        isMaterialIcon: true,
      },
    ],
    isMaterialIcon: true,
    // permission: Permission.SUPPORT_CENTER,
  },
  {
    name: 'Integrations',
    key: 'integrations',
    icon: 'groups',
    link: '/',
    submenu: [
      {
        name: 'Payment Gateway',
        key: 'payment-gateway',
        icon: 'bx bx-credit-card',
        link: AppFullRoutes.FULL_PAYMENT_GATEWAY,
        // permission: Permission.PAYMENT_GATEWAY,
      },
    ],
    isMaterialIcon: true,
    // permission: Permission.SUPPORT_CENTER,
  },
];
